const setLegacyCustomer = (state, response) => {
  state.setLegacyCustomer = response;
};

export default {
  setLegacyCustomer,
};
